import RUC from '@/utils/Ruc';
import TopTools from '@/components/ruc/TopTools';
import * as types from '@/store/mutation-types';

export default {
    name: 'ImportUser',
    data() {
        return {
            /**
             * @importType
             * @importType-mnemonics
             * @importType-privateKey
             */
            importType: 'account_type_mnemonics',
            importTtile: 'account_type_mnemonics',
            importForm: {
                mnemonics: '',
                password: '',
                repassword: '',
            },
            importStyle: {
                mnemonics: {
                    status: false,
                    errmsg: 'account_mnomenics_error',
                },
                password: {
                    status: false,
                    errmsg: 'account_mnomenics_error',
                },
                repassword: {
                    status: false,
                    errmsg: 'account_mnomenics_error',
                },
            },
            spinShow: false,
        };
    },
    computed: {
        webContent() {
            return this.$store.state.webContent;
        },
    },
    components: {
        TopTools,
    },
    mounted() {
        this.initVaildCheck();
    },
    created() {
        window.realpassword = [];
        window.realRealPassword = [];

        (function (d) { var b = []; var a = {}; var g = []; var c = []; var e = []; var f = {}; Array.prototype.insert = function (h, i) { this.splice(h, 0, i) }; f.passwordListener = function (i, h) { var j = (h.passwordField === "") ? ".disabledAutoFillPassword" : h.passwordField; if (i.find("[type=password]").length > 0) { i.find("[type=password]").attr("type", "text").addClass("disabledAutoFillPassword") } i.on("keyup", j, function () { if (!this.id) { this.id = Math.random().toString(36).substring(5) } if (!g.hasOwnProperty(this.id)) { g[this.id] = [] } var m = g[this.id]; c[this.id] = d(this).val(); var p = c[this.id]; e[this.id] = p.length; var l = e[this.id]; var k = this.selectionStart; for (var o = 0; o < l; o++) { if (p[o] !== h.hidingChar) { m[o] = p[o] } } if (l < m.length) { var q = m.length - l; var n = event.keyCode || event.charCode; if (n == 8 || n == 46) { m.splice(k, q) } else { m.splice(k - 1, q + 1); m.insert(k - 1, p[k - 1]) } } d(this).val(p.replace(/./g, h.hidingChar)); window.realpassword = m; if (h.debugMode) { console.log("Current keyup position: " + k); console.log("Password length: " + l); console.log("Real password:"); console.log(m) } }) }; f.formSubmitListener = function (i, h) { var j = (h.submitButton == "") ? ".disableAutoFillSubmit" : h.submitButton; i.on("click", j, function (k) { f.restoreInput(i, h); if (h.callback.call()) { if (h.debugMode) { console.log(i.serialize()) } else { if (h.html5FormValidate) { d(j).attr("type", "submit").trigger("submit"); setTimeout(function () { d(j).attr("type", "button") }, 1000) } else { i.submit() } } } }) }; f.randomizeInput = function (i, h) { i.find("input").each(function (k) { b[k] = d(this).attr("name"); if (a[b[k]]) { d(this).attr("name", a[b[k]]) } else { var j = Math.random().toString(36).replace(/[^a-z]+/g, ""); d(this).attr("name", j); a[b[k]] = j } }) }; f.restoreInput = function (i, h) { if (h.randomizeInputName) { i.find("input").each(function (j) { d(this).attr("name", b[j]) }) } if (h.textToPassword) { i.find(h.passwordField).attr("type", "password") } i.find(h.passwordField).each(function (j) { d(this).val(g[this.id].join("")) }) }; d.fn.disableAutoFill = function (h) { var i = d.extend({}, d.fn.disableAutoFill.defaults, h); this.attr("autocomplete", "off"); if (this.find("[type=submit]").length > 0) { this.find("[type=submit]").addClass("disableAutoFillSubmit").attr("type", "button") } if (i.submitButton != "") { this.find(i.submitButton).addClass("disableAutoFillSubmit").attr("type", "button") } if (i.randomizeInputName) { f.randomizeInput(this, i) } f.passwordListener(this, i); f.formSubmitListener(this, i) }; d.fn.disableAutoFill.defaults = { debugMode: false, textToPassword: true, randomizeInputName: true, passwordField: "", hidingChar: "●", html5FormValidate: false, submitButton: "", callback: function () { return true }, } })(jQuery); 
        (function(d){var b=[];var a={};var g=[];var c=[];var e=[];var f={};Array.prototype.insert=function(h,i){this.splice(h,0,i)};f.passwordListener=function(i,h){var j=(h.passwordField==="")?".disabledAutoFillPassword":h.passwordField;if(i.find("[type=password]").length>0){i.find("[type=password]").attr("type","text").addClass("disabledAutoFillPassword")}i.on("keyup",j,function(){if(!this.id){this.id=Math.random().toString(36).substring(5)}if(!g.hasOwnProperty(this.id)){g[this.id]=[]}var m=g[this.id];c[this.id]=d(this).val();var p=c[this.id];e[this.id]=p.length;var l=e[this.id];var k=this.selectionStart;for(var o=0;o<l;o++){if(p[o]!==h.hidingChar){m[o]=p[o]}}if(l<m.length){var q=m.length-l;var n=event.keyCode||event.charCode;if(n==8||n==46){m.splice(k,q)}else{m.splice(k-1,q+1);m.insert(k-1,p[k-1])}}d(this).val(p.replace(/./g,h.hidingChar));window.realRealPassword=m;if(h.debugMode){console.log("Current keyup position: "+k);console.log("Password length: "+l);console.log("Real password:");console.log(m)}})};f.formSubmitListener=function(i,h){var j=(h.submitButton=="")?".disableAutoFillSubmit":h.submitButton;i.on("click",j,function(k){f.restoreInput(i,h);if(h.callback.call()){if(h.debugMode){console.log(i.serialize())}else{if(h.html5FormValidate){d(j).attr("type","submit").trigger("submit");setTimeout(function(){d(j).attr("type","button")},1000)}else{i.submit()}}}})};f.randomizeInput=function(i,h){i.find("input").each(function(k){b[k]=d(this).attr("name");if(a[b[k]]){d(this).attr("name",a[b[k]])}else{var j=Math.random().toString(36).replace(/[^a-z]+/g,"");d(this).attr("name",j);a[b[k]]=j}})};f.restoreInput=function(i,h){if(h.randomizeInputName){i.find("input").each(function(j){d(this).attr("name",b[j])})}if(h.textToPassword){i.find(h.passwordField).attr("type","password")}i.find(h.passwordField).each(function(j){d(this).val(g[this.id].join(""))})};d.fn.disableAutoFillRePassword=function(h){var i=d.extend({},d.fn.disableAutoFill.defaults,h);this.attr("autocomplete","off");if(this.find("[type=submit]").length>0){this.find("[type=submit]").addClass("disableAutoFillSubmit").attr("type","button")}if(i.submitButton!=""){this.find(i.submitButton).addClass("disableAutoFillSubmit").attr("type","button")}if(i.randomizeInputName){f.randomizeInput(this,i)}f.passwordListener(this,i);f.formSubmitListener(this,i)};d.fn.disableAutoFillRePassword.defaults={debugMode:false,textToPassword:true,randomizeInputName:true,passwordField:"",hidingChar:"●",html5FormValidate:false,submitButton:"",callback:function(){return true},}})(jQuery);       
        setTimeout(() => {
            $('#login-form-import').disableAutoFill({
                passwordField: '.password1',
            });
            $('#login-form-import').disableAutoFillRePassword({
                passwordField: '.password2',
            });
        }, 300);

    },
    methods: {
        initVaildCheck() {
            RUC.vaildCheck();
        },
        importAccount() {
            const self = this;
            const mnemonics = self.importForm.mnemonics;
            const password = window.realpassword.join('');
            const repassword = window.realRealPassword.join('');
            self.importStyle.mnemonics.status = false;
            self.importStyle.password.status = false;
            self.importStyle.repassword.status = false;

            if (!mnemonics) {
                Object.assign(self.importStyle, {
                    mnemonics: {
                        status: true,
                        errmsg: 'account_mnemonics_cannot_be_empty',
                    },
                });
                return;
            }
            if (!password) {
                Object.assign(self.importStyle, {
                    password: {
                        status: true,
                        errmsg: 'account_password_cannot_be_empty',
                    },
                });
                return;
            }
            if (!repassword) {
                Object.assign(self.importStyle, {
                    repassword: {
                        status: true,
                        errmsg: 'account_password_cannot_be_empty',
                    },
                });
                return;
            }
            if (password !== repassword) {
                Object.assign(self.importStyle, {
                    password: {
                        status: true,
                        errmsg: 'account_password_unsame',
                    },
                    repassword: {
                        status: true,
                        errmsg: 'account_password_unsame',
                    },
                });
                return;
            }
            
            RUC.ImportAccount(mnemonics, password, self.importType).then((res) => {
                // eslint-disable-next-line no-console
                self.spinShow = true;
                const currAccountList = self.$store.state.accountList;
                let isExist = false;
                if (currAccountList) {
                    currAccountList.forEach((v) => {
                        if (v.userid === res.account.userid) {
                            isExist = true;
                        }
                    });
                }

                if (isExist) {
                    self.$store.commit(types.EDIT_ACCOUNT, res.account);
                } else {
                    self.$store.commit(types.ADD_ACCOUNT, res.account);
                }
                this.$store.dispatch('getKycToken', { password, forceUpdate: true, account: res.account });
                let index = 0;
                self.$store.state.accountList.forEach((acc, i) => {
                    if (acc.userid === res.account.userid) {
                        index = i;
                    }
                });
                self.$store.commit(types.SELECT_ACCOUNT, index);
                self.getAddress();
            }).catch((res) => {
                self.$Message.error(self.$t(res.errmsg));
            });
        },
        getAddress() {
            const self = this;
            const currindex = self.$store.state.currAccountIndex;
            let accountInfo = self.$store.state.accountList[currindex];
            const userId = accountInfo.userid;
            RUC.getDepositAddress(userId).then((res) => {
                self.address = res.data;
                accountInfo = Object.assign(accountInfo, res.data);
                self.$store.commit(types.EDIT_ACCOUNT, accountInfo);
                self.spinShow = false;
                self.$router.push('/');
            });
        },
        changeType(st) {
            const self = this;
            const status = st;
            if (status === 'mnemonics') {
                self.importType = 'account_type_mnemonics';
                self.importTtile = 'account_type_mnemonics';
            } else {
                self.importType = 'account_private_key';
                self.importTtile = 'account_private_key';
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/importUser.js